import { render, staticRenderFns } from "./NoteEditor.vue?vue&type=template&id=50fbe14a&scoped=true&"
import script from "./NoteEditor.vue?vue&type=script&lang=js&"
export * from "./NoteEditor.vue?vue&type=script&lang=js&"
import style0 from "./NoteEditor.vue?vue&type=style&index=0&id=50fbe14a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fbe14a",
  null
  
)

export default component.exports